/* LEGAL: revisar com advogado antes de go-live */
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export function TermsPage() {
  const navigate = useNavigate();
  return (
    <div className="min-h-full bg-surface">
      <div className="max-w-3xl mx-auto px-4 py-10">
        <button onClick={() => navigate(-1)} className="flex items-center gap-2 text-ink-muted hover:text-ink text-sm mb-8">
          <ArrowLeft className="w-4 h-4" /> Voltar
        </button>

        <div className="prose prose-sm max-w-none text-ink">
          <h1 className="font-display font-bold text-2xl text-ink mb-2">Termos de Uso — MYND BPO</h1>
          <p className="text-xs text-ink-muted mb-8">Versão 1.1 — última atualização: julho de 2026</p>

          <h2 className="font-semibold text-lg text-ink mt-6 mb-2">1. Aceitação dos termos</h2>
          <p className="text-ink-muted mb-4">
            Ao criar uma conta ou utilizar qualquer funcionalidade da plataforma MYND BPO ("Plataforma"), você concorda integralmente com estes Termos de Uso. Se não concordar, não utilize a Plataforma.
          </p>

          <h2 className="font-semibold text-lg text-ink mt-6 mb-2">2. Descrição do serviço</h2>
          <p className="text-ink-muted mb-4">
            O MYND BPO é uma plataforma SaaS de gestão financeira e de e-commerce voltada para empresas. A Plataforma oferece ferramentas para controle financeiro, conciliação bancária, importação de extratos, gestão de pedidos de marketplace e, por meio do módulo MYND Farms, marketplace de serviços de impressão 3D.
          </p>

          <h2 className="font-semibold text-lg text-ink mt-6 mb-2">3. Responsabilidades do usuário</h2>
          <ul className="list-disc pl-5 text-ink-muted space-y-2 mb-4">
            <li>Fornecer informações verdadeiras e manter os dados cadastrais atualizados.</li>
            <li>Manter sigilo das credenciais de acesso. A Plataforma não se responsabiliza por acessos indevidos causados por descuido do usuário.</li>
            <li>Utilizar a Plataforma em conformidade com a legislação brasileira vigente.</li>
            <li>Não realizar operações fraudulentas ou que violem direitos de terceiros.</li>
          </ul>

          <h2 className="font-semibold text-lg text-ink mt-6 mb-2">4. Responsabilidades da Plataforma</h2>
          <p className="text-ink-muted mb-4">
            A Plataforma atua como intermediária de informações e não se responsabiliza pela qualidade de serviços prestados por terceiros (fornecedores no módulo Farms), pela exatidão de dados externos (cotações, extratos bancários de terceiros) ou por decisões financeiras tomadas com base nas informações exibidas.
          </p>

          <h2 className="font-semibold text-lg text-ink mt-6 mb-2">5. Limitação de responsabilidade</h2>
          <p className="text-ink-muted mb-4">
            Na máxima extensão permitida por lei, a Plataforma não responde por danos diretos, indiretos, incidentais ou consequentes decorrentes do uso ou da impossibilidade de uso dos serviços, incluindo lucros cessantes ou perda de dados.
          </p>

          <h2 className="font-semibold text-lg text-ink mt-6 mb-2">6. Módulo MYND Farms — condições específicas</h2>
          <ul className="list-disc pl-5 text-ink-muted space-y-2 mb-4">
            <li>A Plataforma cobra uma <strong>porcentagem de operação</strong> em cada transação concluída no módulo Farms.</li>
            <li>Fornecedores são responsáveis por entregar os serviços conforme descrito em seus perfis.</li>
            <li>Clientes são responsáveis pela correção das especificações enviadas (material, dimensões, prazo).</li>
            <li>Esclarecimentos e disputas devem ser resolvidas preferencialmente via chat in-app. A Plataforma não atua como árbitro.</li>
            <li>A integração de pagamento via Mercado Pago Marketplace estará disponível em versão futura. Na versão atual o pagamento é simulado.</li>
          </ul>

          <h2 className="font-semibold text-lg text-ink mt-6 mb-2">7. Integrações, credenciais e dados financeiros</h2>
          <ul className="list-disc pl-5 text-ink-muted space-y-2 mb-4">
            <li>Ao conectar integrações (ex.: Mercado Livre via OAuth ou seu banco via Open Finance/Pluggy), você <strong>autoriza expressamente</strong> a coleta e o tratamento dos dados necessários àquela funcionalidade. A conexão é sempre iniciada e confirmada por você.</li>
            <li>A MYND <strong>não armazena senhas bancárias</strong>. A autenticação Open Finance ocorre no provedor licenciado; a MYND recebe apenas tokens de leitura, guardados de forma cifrada.</li>
            <li>Dados financeiros exibidos (saldos, cotações, extratos, métricas) têm caráter informativo. Decisões tomadas com base neles são de responsabilidade do usuário.</li>
            <li>Você pode desconectar qualquer integração a qualquer momento, cessando a coleta futura.</li>
            <li>É proibido inserir credenciais, tokens ou dados de terceiros sem autorização legítima.</li>
          </ul>

          <h2 className="font-semibold text-lg text-ink mt-6 mb-2">8. Dados sensíveis e consentimento em atualizações</h2>
          <p className="text-ink-muted mb-4">
            Novas funcionalidades que envolvam aprovação, coleta permanente ou dados sensíveis (por exemplo, novas
            fontes de API, dados financeiros ou bancários) só serão ativadas mediante <strong>consentimento
            específico</strong> do usuário, apresentado na própria Plataforma. Atualizações que não envolvam dados
            sensíveis podem ser apenas comunicadas de forma informativa. O tratamento de dados observa a Política
            de Privacidade e a LGPD.
          </p>

          <h2 className="font-semibold text-lg text-ink mt-6 mb-2">9. Conduta no chat e comunicação</h2>
          <ul className="list-disc pl-5 text-ink-muted space-y-2 mb-4">
            <li>A negociação deve ocorrer dentro da Plataforma. Por segurança e prevenção a fraudes, o envio de <strong>telefones, CEP ou outros números de contato</strong> no chat é bloqueado.</li>
            <li>É vedado usar o chat para assédio, spam, conteúdo ilícito ou tentativa de contornar a Plataforma.</li>
            <li>Condutas abusivas podem ser denunciadas e resultam em suspensão da conta.</li>
          </ul>

          <h2 className="font-semibold text-lg text-ink mt-6 mb-2">10. Arquivos e propriedade dos projetos (Farms)</h2>
          <ul className="list-disc pl-5 text-ink-muted space-y-2 mb-4">
            <li>Ao enviar arquivos, referências ou desenhos técnicos para cotação/modelagem, você declara possuir os direitos necessários sobre esse conteúdo.</li>
            <li>Os arquivos são compartilhados com a farm escolhida apenas para viabilizar orçamento e produção.</li>
            <li>A MYND não reivindica propriedade sobre seus projetos, mas não se responsabiliza pelo uso indevido por terceiros fora da Plataforma.</li>
          </ul>

          <h2 className="font-semibold text-lg text-ink mt-6 mb-2">11. Exclusão de conta e retenção</h2>
          <p className="text-ink-muted mb-4">
            Você pode excluir sua conta a qualquer momento, desde que não haja pedidos em aberto (pendentes,
            aguardando aprovação ou em impressão). Ao excluir, login e senha são eliminados e os dados pessoais e
            operacionais removidos. Para fins comerciais legítimos, antifraude e obrigações legais, a MYND retém um
            registro mínimo (e-mail, nome e documento), conforme a Política de Privacidade. Um novo cadastro com o
            mesmo e-mail é tratado como um usuário inteiramente novo.
          </p>

          <h2 className="font-semibold text-lg text-ink mt-6 mb-2">12. Propriedade intelectual</h2>
          <p className="text-ink-muted mb-4">
            Todo o conteúdo da Plataforma (código, design, marca MYND BPO) é de propriedade exclusiva dos seus criadores. É vedada a reprodução, distribuição ou engenharia reversa sem autorização prévia e por escrito.
          </p>

          <h2 className="font-semibold text-lg text-ink mt-6 mb-2">13. Rescisão e cancelamento</h2>
          <p className="text-ink-muted mb-4">
            O usuário pode encerrar sua conta a qualquer momento. A Plataforma pode suspender ou encerrar contas que violem estes Termos. Os dados serão tratados conforme a Política de Privacidade após o encerramento.
          </p>

          <h2 className="font-semibold text-lg text-ink mt-6 mb-2">14. Alterações nos termos</h2>
          <p className="text-ink-muted mb-4">
            Estes Termos podem ser atualizados a qualquer tempo. O usuário será notificado por e-mail e, ao continuar usando a Plataforma após a notificação, estará aceitando os novos termos.
          </p>

          <h2 className="font-semibold text-lg text-ink mt-6 mb-2">15. Foro</h2>
          <p className="text-ink-muted mb-4">
            Fica eleito o foro da comarca de São Paulo/SP, Brasil, para dirimir quaisquer controvérsias decorrentes destes Termos, com renúncia de qualquer outro, por mais privilegiado que seja.
          </p>
        </div>
      </div>
    </div>
  );
}
